module.exports = __webpack_public_path__ + "view_magnify_lightgray_search_type.7dc55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/view_magnify_lightgray_search_type.svg
// module id = ./src/_asset/sources/assets/images/@svg/view_magnify_lightgray_search_type.svg
// module chunks = main